import { render, staticRenderFns } from "./hwk-left.vue?vue&type=template&id=474db5b6&scoped=true"
import script from "./hwk-left.vue?vue&type=script&lang=js"
export * from "./hwk-left.vue?vue&type=script&lang=js"
import style0 from "./hwk-left.vue?vue&type=style&index=0&id=474db5b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474db5b6",
  null
  
)

export default component.exports